import { Container, Grid, createTheme, useMediaQuery } from '@mui/material'
import {
  Route,
  BrowserRouter as Router,
  Routes
} from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import './App.css'
import { Footer, NavBar, NavBarMobile } from './components'
import useGlobalStore from './stores/global'
import { constructTheme } from './themes'
import { Dashboard, Market } from './views'
import TokenDetails from './views/TokenDetails'
import { MobileTabWrapper } from './Layout'
import InputForm from './components/token-details/InputForm'
import InputFormStats from './components/token-details/InputFormStats'
import { useEffect } from 'react'
import { useAccount } from 'wagmi'

function App() {

  const themeMode = useGlobalStore((state) => state.theme)
  const seedStore = useGlobalStore((state) => state.seedStore)
  const setUserAddress = useGlobalStore((state) => state.setUserAddress)
  const theme = createTheme(constructTheme(themeMode))
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const { address, isConnected } = useAccount();

  const NavBarComponent = isMobile ? NavBarMobile : NavBar
  console.log("Network:", process.env.REACT_APP_NETWORK)
  useEffect(() => {
    //initialize fetching
    seedStore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setUserAddress(isConnected ? address : undefined)
    if (isConnected) seedStore() //reseed store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, isConnected])


  const TokenDetailsView = isSmallerScreen ?
    <MobileTabWrapper
      tabs={[<TokenDetails />, <Grid container gap={2}><InputForm /><InputFormStats /></Grid>]}
      tabsName={['Overview', 'My Position']}
    /> : <TokenDetails />

  return (

    <ThemeProvider theme={theme}>
      <Router>
        <div className={`App App-${themeMode}`}>
          <NavBarComponent />
          <Container style={{ maxWidth: 1400 }}>
            <Routes>
              <Route path="/token/:denom" element={TokenDetailsView} />
              <Route path="/portfolio" element={<Dashboard />} />
              <Route path="*" element={<Market />} />
            </Routes>
          </Container>
          <Footer />
        </div>
      </Router>
    </ThemeProvider >
  )
}

export default App
